
import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import UserDataCont from './UserDataCont';


const UserTables = () => {
    document.title = "Users";
    const [isAddModalOpen, setAddModalOpen] = useState(false);
    const [newUser, setNewUser] = useState({
        // name: "",
        firstName: '',
        lastName: '',
        email: "",
        password: "",
        role: "",
      });
    const closeModal = () => {
        setAddModalOpen(false);
        setNewUser({
            // name: "",
            firstName: '',
            lastName: '',
            email: "",
            password: "",
            role: "",
        });    
    };

    const openAddModal = () => {
        setAddModalOpen(true);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <UserDataCont
                                        isAddModalOpen={isAddModalOpen}
                                        closeModal={closeModal}
                                        setNewUser={setNewUser}
                                        newUser={newUser}
                                        setAddModalOpen={setAddModalOpen} 
                                        openAddModal={openAddModal}
                                        />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default UserTables;